
export const ImageBaseUrl = 'http://3.20.6.42:3000/uploads/image/';